export default "__VITE_ASSET__595420d4__"